import { render, staticRenderFns } from "./knowledgeindex.vue?vue&type=template&id=5bbf4f38&scoped=true&"
import script from "./knowledgeindex.vue?vue&type=script&lang=js&"
export * from "./knowledgeindex.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeindex.vue?vue&type=style&index=0&id=5bbf4f38&prod&lang=scss&scoped=true&"
import style1 from "./knowledgeindex.vue?vue&type=style&index=1&id=5bbf4f38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbf4f38",
  null
  
)

export default component.exports